import React from 'react';
export const SubscriptionPlansContext = React.createContext({
  setSubscriptionPlans: (subscriptionPlans) => {},
  subscriptionPlans: [],
});
